import { render, staticRenderFns } from "./ResultComponent.vue?vue&type=template&id=3a102941&"
import script from "./ResultComponent.vue?vue&type=script&lang=js&"
export * from "./ResultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports